import { render, staticRenderFns } from "./AiModelsSettings.vue?vue&type=template&id=aae037e2&scoped=true"
import script from "./AiModelsSettings.vue?vue&type=script&lang=js"
export * from "./AiModelsSettings.vue?vue&type=script&lang=js"
import style0 from "./AiModelsSettings.vue?vue&type=style&index=0&id=aae037e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae037e2",
  null
  
)

export default component.exports